import { forwardRef } from 'react';

interface AtmosphericBackgroundProps {
  variant?: 'aurora' | 'nebula' | 'moonlight';
  className?: string;
}

export const AtmosphericBackground = forwardRef<HTMLDivElement, AtmosphericBackgroundProps>(
  ({ variant = 'aurora', className = '' }, ref) => {
    return (
      <div ref={ref} className={`absolute inset-0 overflow-hidden pointer-events-none z-0 ${className}`} aria-hidden="true">
        {variant === 'aurora' && (
          <>
            <div
              className="absolute inset-0 animate-aurora-shift"
              style={{
                background: `
                  radial-gradient(ellipse 60% 40% at 20% 50%, hsl(260 40% 25% / 0.12), transparent),
                  radial-gradient(ellipse 50% 50% at 80% 30%, hsl(42 60% 50% / 0.06), transparent),
                  radial-gradient(ellipse 70% 30% at 50% 80%, hsl(200 50% 30% / 0.08), transparent)
                `,
              }}
            />
            <div
              className="absolute inset-0 animate-aurora-shift-alt"
              style={{
                background: `
                  radial-gradient(ellipse 40% 60% at 70% 60%, hsl(280 35% 30% / 0.08), transparent),
                  radial-gradient(ellipse 50% 40% at 30% 20%, hsl(42 70% 55% / 0.04), transparent)
                `,
              }}
            />
          </>
        )}
        {variant === 'nebula' && (
          <div
            className="absolute inset-0 animate-nebula-pulse"
            style={{
              background: `
                radial-gradient(ellipse 50% 50% at 30% 40%, hsl(270 40% 25% / 0.1), transparent),
                radial-gradient(ellipse 40% 60% at 70% 60%, hsl(42 50% 45% / 0.07), transparent),
                radial-gradient(ellipse 60% 30% at 50% 20%, hsl(220 50% 20% / 0.1), transparent)
              `,
            }}
          />
        )}
        {variant === 'moonlight' && (
          <div
            className="absolute inset-0"
            style={{
              background: `
                radial-gradient(ellipse 40% 40% at 75% 15%, hsl(42 40% 60% / 0.08), transparent),
                radial-gradient(ellipse 80% 50% at 50% 100%, hsl(220 30% 10% / 0.3), transparent)
              `,
            }}
          />
        )}
      </div>
    );
  }
);

AtmosphericBackground.displayName = 'AtmosphericBackground';
